import React, { Component } from 'react';
import {
    Router,
    Route,
    Switch
} from 'react-router-dom';

import Mentors from './components/Mentors';
import NotFound from './components/NotFound';
import Intro from './components/Intro';
import BecomeAMentor from './components/BecomeAMentor';
import Auth from './Auth/Auth';
import history from './history';
import Callback from './components/Callback';

class App extends Component {

    constructor(props) {
        super(props);
        this.auth = new Auth();
    }

    handleAuthentication = (nextState, replace) => {
        if (/access_token|id_token|error/.test(nextState.location.hash)) {
            this.auth.handleAuthentication();
        }
    };

    render() {
        return (
            <Router history={history}>
                <div>
                    <Switch>
                        {/* <Route exact path="/" render={() => <Intro />} /> */}
                        <Route exact path="/becomeamentor" render={() => <BecomeAMentor store={this.props.store} />} />
                        <Route exact path="/" render={() => <Mentors store={this.props.store} />} />
                        <Route render={() => <NotFound />} />
                    </Switch>
                </div>
            </Router>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js